import { IJourneyInformation } from '../../idscan/interfaces/Journey';
import { IPoint } from '../../idscan/interfaces/Point';

/**
 * @class TransformationService
 *
 * @internal
 */
export class TransformationService {
	/**
	 * Base method that will map the conversions between various smaller but different functions
	 * @param type
	 * @param beautify
	 * @param element
	 */
	public static convert = (type: string, element: any): any => {
		let result;
		switch (type) {
			case 'coordinates':
				result = TransformationService.coordinates(element);
				break;
			case 'journey-retrieval':
				result = TransformationService.journeyRetrievalObject(element);
				break;
			case 'journey-upload':
				result = TransformationService.journeyUploadObject(element);
				break;
			default:
				break;
		}

		return result;
	}

	private static coordinates(element: number[][]): IPoint[];
	private static coordinates(element: IPoint[]): number[][];
	private static coordinates(element: any): any {
		let result: IPoint[] | number[][] = [];
		if (element instanceof Array && element.length === 4) {
			if ('x' in element[0]) {
				const coords: number[][] = [];

				element.map((point) => {
					if ('x' in point && 'y' in point) {
						coords.push([point.x, point.y]);
					}
				});

				result = coords;
			} else {
				const coords: IPoint[] = [];
				element.map((point: number[]) => {
					if (point.length === 2) {
						coords.push({
							x: point[0],
							y: point[1],
						});
					}
				});

				result = coords;
			}
		}

		return result;
	}

	private static journeyRetrievalObject = <T = any>(element: T): T => {
		return 'sample' as any as T;
	}

	private static journeyUploadObject = <T extends { data: any } = { data: any }>(element: T): T => {
		if (element.data) {
			if (element.data.entryData) {
				const ed = element.data.entryData;
				const info: IJourneyInformation = {
					documents: [],
					holder: {
						address: {
							city: ed['ExtractedFields.AddressCity'] ? ed['ExtractedFields.AddressCity'] : undefined,
							full: ed['ExtractedFields.AddressFull'] ? ed['ExtractedFields.AddressFull'] : undefined,
							postCode: ed['ExtractedFields.AddressPostCode'] ? ed['ExtractedFields.AddressPostCode'] : undefined,
						},
						birthDate: ed['ExtractedFields.BirthDate'] ? ed['ExtractedFields.BirthDate'] : undefined,
						birthPlace: ed['ExtractedFields.BirthPlace'] ? ed['ExtractedFields.BirthPlace'] : undefined,
						firstName: ed['ExtractedFields.FirstName'] ? ed['ExtractedFields.FirstName'] : undefined,
						fullName: ed['ExtractedFields.FullName'] ? ed['ExtractedFields.FullName'] : undefined,
						gender: ed['ExtractedFields.Sex'] ? ed['ExtractedFields.Sex'] : undefined,
						lastName: ed['ExtractedFields.LastName'] ? ed['ExtractedFields.LastName'] : undefined,
						middleName: ed['ExtractedFields.MiddleName'] ? ed['ExtractedFields.MiddleName'] : undefined
					},
					scanReference: ed['ScanReference'] ? ed['ScanReference'] : undefined,
					scannerIp: ed['ScannerIp'] ? ed['ScannerIp'] : undefined,
					glareCheck: ed['QualityChecks.GlareCheck'] ? ed['QualityChecks.GlareCheck'] : undefined,
					blurCheck: ed['QualityChecks.BlurCheck'] ? ed['QualityChecks.BlurCheck'] : undefined,
					lowResolutionCheck: ed['QualityChecks.LowResolutionCheck'] ? ed['QualityChecks.LowResolutionCheck'] : undefined,
					fullDocumentInViewCheck: ed['QualityChecks.FullDocumentInViewCheck'] ? ed['QualityChecks.FullDocumentInViewCheck'] : undefined,
					tripleScanReason: ed['TripleScanReason'] ? ed['TripleScanReason'] : undefined
				};

				const currentDocument = {
					expirationDate: ed['ExtractedFields.ExpiryDate'] ? ed['ExtractedFields.ExpiryDate'] : undefined,
					issueDate: ed['ExtractedFields.IssueDate'] ? ed['ExtractedFields.IssueDate'] : undefined,
					issueNumber: ed['ExtractedFields.IssueNumber'] ? ed['ExtractedFields.IssueNumber'] : undefined,
					number: ed['ExtractedFields.DocumentNumber'] ? ed['ExtractedFields.DocumentNumber'] : undefined,
					covid: ed['ExtractedFields.COVIDPASSCROSSCHECKRESULT'] ? ed['ExtractedFields.COVIDPASSCROSSCHECKRESULT'] : undefined,
					type: ed['documentType'] ? ed['documentType'] : undefined
				};

				info.documents.push(currentDocument);

				element.data.entryData = info;
			}
		}

		return element;
	}

}
